

























































import { Getter } from 'vuex-class';
import { Vue, Component } from 'vue-property-decorator';
import { Destination } from '../../../store/destinations/types';
import { required } from 'vuelidate/lib/validators';
import { routeTo } from '@/api/reactor/reactions';

@Component({
    validations: {
        form: {
            name: {
                required
            },
            latitude: {
                required
            },
            longitude: {
                required
            }
        }
    },
    reactions: {
      '$destinations/destinationCreated': routeTo('destinations'),
      '$destinations/destinationUpdated': routeTo('destinations')
    }
})
export default class DestinationForm extends Vue {
  mode: string = 'create';
  form: any = {
    id: 'new',
    name: '',
    latitude: '',
    longitude: '',
    description: '',
  };
  loading: boolean = false;

  get nameErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.name) {
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push('Name is required.');
    }
    return errors
  }

  get latitudeErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.latitude) {
      if (!this.$v.form.latitude.$dirty) return errors;
      !this.$v.form.latitude.required && errors.push('Latitude is required.');
    }
    return errors
  }

  get longitudeErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.longitude) {
      if (!this.$v.form.longitude.$dirty) return errors;
      !this.$v.form.longitude.required && errors.push('Longitude is required.');
    }
    return errors
  }

  @Getter('$destinations/currentDestination') selected: Destination | undefined;

  async mounted() {
    const self = this;
    if (this.$route.params.did == 'new') {
      // new destination
      this.mode = 'create';
      this.form.id = 'new';
    } else {
      // load destination to update
      this.mode = 'update';
      await this.$store.dispatch('$destinations/select', self.$route.params.did);
      if (!!this.selected) {
        this.form.id = this.selected.id;
        this.form.name = this.selected.name;
        this.form.latitude = this.selected.latitude;
        this.form.longitude = this.selected.longitude;
        this.form.description = this.selected.description;
      }
    }
  }

  async onSubmit() {
    this.loading = true;
    if (this.mode === 'create') {
      await this.$store.dispatch('$destinations/create', this.form);
    } else {
      await this.$store.dispatch('$destinations/update', this.form);
    }
    this.loading = false;
  }
}
